import { Navigate } from "react-router-dom";
import { hasPermission } from "../../utils/permission";

function PermissionRoute({
    permission,
    children
}){

    if(
        !hasPermission(permission)
    ){
        return <Navigate to="/admin/dashboard"/>;
    }

    return children;

}

export default PermissionRoute;